// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react'
import {dynamicBaseQuery} from "../badRequestHandler"
// Define a service using a base URL and expected endpoints
export const employee = createApi({
  reducerPath: 'employee',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Employee', 'SalesIncentiveSlab', 'RevenueIncentiveSlab'] as const,
  endpoints: (builder) => ({
    addEmployee: builder.mutation({
      query: (body) => ({
        url: `/employees`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['Employee'],
    }),
    getEmployee: builder.query({
      query: (params) => ({
        url: `/employees`,
        method: "GET",
        params,
      }),
      providesTags: ['Employee'],
    }),
    getOpenEmployees: builder.query({
      query: (params) => ({
        url: `/employees/open`,
        method: "GET",
        params,
      }),
      providesTags: ['Employee'],
    }),
    getEmployeeDetail: builder.query({
      query: (id) => ({
        url: `/employees/${id}`,
        method: "GET",
      }),
      providesTags: ['Employee'],
    }),
    getEmployeeByCustomer: builder.query({
      query: (id) => ({
        url: `/employees/by-customer?userId=${id}`,
        method: "GET",
      }),
      providesTags: ['Employee'],
    }),
    updateEmployee: builder.mutation({
      query: ({ id, body }) => ({
        url: `/employees/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ['Employee'],
    }),
    updateEmployeeStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/employees/${id}/status`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ['Employee'],
    }),
    verifyEmployee: builder.mutation({
      query: (id) => ({
        url: `/employees/${id}/verify`,
        method: "PATCH",
      }),
      invalidatesTags: ['Employee'],
    }),
    unverifyEmployee: builder.mutation({
      query: (id) => ({
        url: `/employees/${id}/unverify`,
        method: "PATCH",
      }),
      invalidatesTags: ['Employee'],
    }),
    updateEmployeeIsShow: builder.mutation({
      query: ({ id, isShow }) => ({
        url: `/employees/${id}/is-show`,
        method: "PATCH",
        body: { isShow },
      }),
      invalidatesTags: ['Employee'],
    }),
    getSalesIncentiveSlabs: builder.query({
      query: (employeeId: string) => ({
        url: `/employees/${employeeId}/sales-incentive-slabs`,
        method: "GET",
      }),
      providesTags: ['SalesIncentiveSlab'],
    }),
    addSalesIncentiveSlab: builder.mutation({
      query: ({ employeeId, ...body }: { employeeId: string; saleTitle: string; fromDays: number; toDays: number; percentage: number }) => ({
        url: `/employees/${employeeId}/sales-incentive-slabs`,
        method: "POST",
        body,
      }),
      invalidatesTags: ['SalesIncentiveSlab'],
    }),
    updateSalesIncentiveSlab: builder.mutation({
      query: ({ employeeId, slabId, ...body }: { employeeId: string; slabId: string; saleTitle: string; fromDays: number; toDays: number; percentage: number; status: string }) => ({
        url: `/employees/${employeeId}/sales-incentive-slabs/${slabId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ['SalesIncentiveSlab'],
    }),
    getRevenueIncentiveSlabs: builder.query({
      query: (employeeId: string) => ({
        url: `/employees/${employeeId}/revenue-incentive-slabs`,
        method: "GET",
      }),
      providesTags: ['RevenueIncentiveSlab'],
    }),
    addRevenueIncentiveSlabs: builder.mutation({
      query: ({ employeeId, slabs }: { employeeId: string; slabs: { from: number; to: number; percentage: number; rewardOfMonth?: number; benchmarkRewardName?: string }[] }) => ({
        url: `/employees/${employeeId}/revenue-incentive-slabs`,
        method: "POST",
        body: { slabs },
      }),
      invalidatesTags: ['RevenueIncentiveSlab'],
    }),
    toggleRevenueIncentiveSlab: builder.mutation({
      query: ({ employeeId, incentiveId, status }: { employeeId: string; incentiveId: string; status: 'active' | 'inactive' }) => ({
        url: `/employees/${employeeId}/revenue-incentive-slabs/${incentiveId}/toggle`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: ['RevenueIncentiveSlab'],
    }),

  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useAddEmployeeMutation,useGetEmployeeQuery,useGetOpenEmployeesQuery,useGetEmployeeDetailQuery,useGetEmployeeByCustomerQuery,useUpdateEmployeeMutation, useUpdateEmployeeStatusMutation, useVerifyEmployeeMutation, useUnverifyEmployeeMutation, useUpdateEmployeeIsShowMutation, useGetSalesIncentiveSlabsQuery, useAddSalesIncentiveSlabMutation, useUpdateSalesIncentiveSlabMutation, useGetRevenueIncentiveSlabsQuery, useAddRevenueIncentiveSlabsMutation, useToggleRevenueIncentiveSlabMutation } = employee